module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av429-7d81040b12e1b5332384218d47cfe02c.jpg";